import { render, staticRenderFns } from "./LoadingV.vue?vue&type=template&id=2e778f34&scoped=true&"
var script = {}
import style0 from "./LoadingV.vue?vue&type=style&index=0&id=2e778f34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e778f34",
  null
  
)

export default component.exports